import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../kms.service';
declare var $;  

@Component({
  selector: 'app-label-select',
  templateUrl: './label-select.component.html',
  styleUrls: ['./label-select.component.css']
})
export class LabelSelectComponent implements OnInit {
  // 已选择的标签数组
  @Input() datas: any = [];
  selectedTags: any = [];
  // 标签字段名称
  @Input() attrName: string = '知识标签';
  // 样式 'horizontally':横向；'vertically':竖向
  @Input() labelStyle: string = 'vertically';
  // 选中标签发生变化时向父组件发射数据
  @Output('selectedChange') selectedChange = new EventEmitter<any>();
  // 标签输入框中绑定的值
  currentTag = '';
  // 搜索标签列表
  tagDatasList: any = [];
  // 搜索标签列表选中索引值
  activeTagIndex = -1;
  // 标签分类：其他的id
  parentTagId: string = '';

  constructor(
    private box: SwMassageBoxService,
    private kmsService: KmsService
  ) {
  }

  ngOnInit() {

  }

  ngOnChanges() {
    this.getParentTag();
    this.selectedTags = this.datas;
  }

  // 获取"其他"标签id
  getParentTag() {
    if (this.parentTagId) {
      return;
    }
    this.kmsService.queryTagTree({ tagName: '其他' }).subscribe(result => {
      if (result.code == 200) {
        if (result.data && result.data.length > 0) {
          // 判断当前是否已创建了“其他”分类
          let items = result.data.filter(item => (item.tagName == '其他' && item.tagLevel == 1));
          // 若已创建，将当前标签的父级分类设为“其他”，并保存标签信息
          if (items.length > 0) {
            this.parentTagId = items[0].tagId;
          } else {
            // 创建“其他”标签分类
            this.createOtherTag();
          }
        } else {
          // 创建“其他”标签分类
          this.createOtherTag();
        }
      } else {
        this.box.waring(result.msg);
      }
    });
  }

  // 创建“其他”标签分类
  createOtherTag() {
    // 先创建其他分类
    let params = {
      tagName: '其他',
      tagLevel: 1,
      tagCategory: 2,
      parentId: ''
    }
    this.kmsService.saveTag(params).subscribe(
      data => {
        if (data["code"] == '200') {
          // 将当前标签的父级分类设为“其他”
          this.parentTagId = data.data.tagId;
        } else if(data["code"] != '670'){
          this.box.waring(data.msg);
        }
      }
    )
  }

  // 获取标签列表下拉数据
  getLabelListDatas() {
    let parmas = {
      size: 15,
      current: 1,
      tagCategory: 1,
      tagName: this.currentTag
    }
    this.kmsService.queryTagList(parmas).subscribe(
      result => {
        if (result.code == 200) {
          this.tagDatasList = result.data.records;
        } else {
          this.box.waring(result.msg);
        }
      }
    )
  }

  // 添加标签事件
  handleAddTagClick() {
    let tagName = $.trim(this.currentTag)
    if (tagName) {
      if (tagName.length <= 20) {
        // 先判断该标签是否存在
        this.kmsService.queryTagByName(tagName).subscribe(
          data => {
            if (data.code == '200'){
              if(data.data){
                this.handleSearchTagClick(data.data);
              }else{
                let parmas = {
                  parentId: this.parentTagId,
                  tagLevel: 2,
                  tagCategory: 1,
                  tagName: tagName
                }
                this.kmsService.saveTag(parmas).subscribe(
                  result => {
                    if (result.code == 200) {
                      this.handleSearchTagClick(result.data);
                    } else {
                      this.box.waring(result.msg);
                    }
                  }
                )
              }
            }else{
              this.box.waring(data.msg);
            }
          }
        )
      } else {
        this.box.danger('标签名的最大输入长度为20！');
      }
    } else {
      this.box.info('请输入标签名称！');
    }
  }

  // 删除标签事件
  handleDelTagClick(index) {
    this.selectedTags.splice(index, 1);
    this.selectedChange.emit(this.selectedTags);
  }

  // 标签搜索信息
  handleSearchChange() {
    this.getLabelListDatas();
  }

  // 标签下拉搜索列表点击事件
  handleSearchTagClick(data) {
    this.currentTag = '';
    if (this.selectedTags.length > 0) {
      let items = this.selectedTags.filter(item => item.tagName == data.tagName);
      if (items.length == 0) {
        this.selectedTags.push(data);
      }
    } else {
      this.selectedTags.push(data);
    }
    this.selectedChange.emit(this.selectedTags);
    this.tagDatasList = [];
    this.activeTagIndex = -1;
  }

  // 标签输入框内容发生变化时方法
  handleTagChange(event) {
    // 阻止点击enter键时触发自动补全功能
    if (event.keyCode == '13') {
      let data = this.tagDatasList.filter(item => item.tagName == this.currentTag)[0];
      if (data) {
        this.handleSearchTagClick(data);
      } else {
        this.handleAddTagClick();
      }
      return;
    }
    // 向上选中自动补全列表项
    if (event.keyCode == '38') {
      if (this.tagDatasList.length > 0) {
        if (this.activeTagIndex > 0) {
          this.activeTagIndex--;
          const scrollTop = $('.tagList').scrollTop();
          $('.auto-list').animate({ scrollTop: scrollTop - 30 }, 100);
          this.currentTag = this.tagDatasList[this.activeTagIndex].tagName;
        }
      }
      return;
    }

    // 向下选中自动补全列表项
    if (event.keyCode == '40') {
      if (this.tagDatasList.length > 0) {
        if (this.activeTagIndex < this.tagDatasList.length - 1) {
          this.activeTagIndex++;
          if (this.activeTagIndex > 0) {
            const scrollTop = $('.tagList').scrollTop();
            $('.tagList').animate({ scrollTop: scrollTop + 30 }, 100);
          }
          this.currentTag = this.tagDatasList[this.activeTagIndex].tagName;
        }
      }
      return;
    }

    // 查询自动补全列表
    this.handleFocusFun();
  }

  // 标签输入框获取焦点时方法
  handleFocusFun() {
    this.getLabelListDatas();
  }

  // 标签输入框失去焦点时方法
  handleBlurFun() {
    setTimeout(() => {
      this.tagDatasList = [];
      this.activeTagIndex = -1;
    }, 200);
  }
}
